/**
 * 判断数据是否为空值
 */
export function isNull(data) {
  if (data instanceof Array) {
    if (JSON.stringify(data) === "[]") return true;
  } else if (data instanceof Object) {
    if (JSON.stringify(data) === "{}") return true;
  } else if (data instanceof String) {
    if (data.trim() === "") return true;
  } else {
    if (!data) return true;
  }
  return false;
}

/**
 * 根据其他对象的属性值，对当前对象进行赋值
 * @param {*} obj
 * @param {*} otherObj
 */
export function copyByOtherObj(obj, otherObj) {
  for (let key in otherObj) {
    if (obj.hasOwnProperty(key)) {
      obj[key] = otherObj[key];
    }
  }
}

/**
 * 对象根据另一个对象进行赋值,只赋值自身有的属性
 */
export const assignmentSelfProp = (object, assObject) => {
  for (let key in object) {
    if (assObject.hasOwnProperty(key)) {
      object[key] = assObject[key];
    }
  }
};

// 设置数据的父节点等信息
export const setParentId = (parentNode, data) => {
  data.parentId = parentNode.organId; // 当前节点父ID
  // 对 companyId 和 companyUnitId 属性进行赋值
  if (parentNode.nodeType !== "root") {
    if (parentNode.companyId === "" || parentNode.companyId === null) {
      data.companyId = parentNode.organId;
    } else {
      data.companyId = parentNode.companyId;
      if (
        parentNode.companyUnitId === "" ||
        parentNode.companyUnitId === null
      ) {
        data.companyUnitId = parentNode.organId;
      } else {
        data.companyUnitId = parentNode.companyUnitId;
      }
    }
  }
  // 对是否有下级节点进行赋值
  if (data.nodeType !== "family") {
    data.hasChild = "1";
  } else {
    data.hasChild = "0";
  }
};

/**
 * 数据拼接成字符串
 * @param {Array} list 数组
 * @param {String} attr 数组中对象的字段
 * @param {String} joinStr 拼接的字符串
 * @returns
 */
export const feArrayObjectJoin = (list, attr, joinStr) => {
  if (!list) return null;
  if (list.length > 0) {
    return list.map((item) => item[attr]).join(joinStr);
  } else {
    return null;
  }
};

// 深度拷贝
export const deepClone = (obj) => {
  if (obj === null) return obj;
  //判断拷贝的obj是对象还是数组
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    //obj不能为空，并且是对象或者是数组 因为null也是object
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && typeof obj[key] === "object") {
          //obj里面属性值不为空并且还是对象，进行深度拷贝
          objClone[key] = deepClone(obj[key]); //递归进行深度的拷贝
        } else {
          objClone[key] = obj[key]; //直接拷贝
        }
      }
    }
  }
  return objClone;
};

// 获取时间
export const getDay = (day) => {
  const data = new Date();
  let targetDay_milliseconds = data.getTime() + 1000 * 60 * 60 * 24 * day;
  data.setTime(targetDay_milliseconds);

  return getFormatDate(data);
};
// 获取格式化的日期
export const getFormatDate = (date) => {
  let y = date.getFullYear();
  let m = date.getMonth();
  let d = date.getDate();

  m = doHandleMonth(m + 1);
  d = doHandleMonth(d);
  const resDate = `${y}-${m}-${d}`;

  return resDate;
};

// 如果为个位数在前边加0
const doHandleMonth = (month) => {
  let m = month;
  if (month.toString().length === 1) {
    m = "0" + month;
  }
  return m;
};

/**
 * 获取随机数
 * @param {*} min  最小值
 * @param {*} max   最大值
 */
export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

// 阿里oss 文件桶与腾讯 cos 文件桶对应关系
const cosOssDict = {
  fangererpdata: "fangererpdata-1351264140",
  filestandardstorage: "filestandardstorage-1351264140",
  "fanger-ota-package": "fanger-ota-package-1351264140",
  "fanger-software-package": "software-package-1351264140",
  "fanger-wechat-miniprogram": "wechat-miniprogram-1351264140",
};
const aliyunUrl = ".oss-cn-zhangjiakou.aliyuncs.com";
const tengxunUrl = ".cos.ap-beijing.myqcloud.com";

// 获取单个URL 转换
export const getCosFileUrl = (url) => {
  let reUrl = url;
  if (isNull(url)) return reUrl;
  if (url.includes(aliyunUrl)) {
    Object.keys(cosOssDict).forEach((key) => {
      if (url.includes(key)) {
        reUrl = url.replace(key + aliyunUrl, cosOssDict[key] + tengxunUrl);
        return reUrl;
      }
    });
    return reUrl;
  } else {
    return reUrl;
  }
};

// 获取多个URL 转换
export const getCosFileUrlByUrlList = (urlList) => {
  if (isNull(urlList)) return urlList;
  const reUrlList = [];
  urlList.forEach((url) => {
    reUrlList.push(getCosFileUrl(url));
  });
  return reUrlList;
};

//type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，months为数字类型，不传或0代表本月，-1代表上月，1代表下月
export const getMonth = (type, months) => {
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  if (Math.abs(months) > 12) {
    months = months % 12;
  }
  if (months != 0) {
    if (month + months > 12) {
      year++;
      month = (month + months) % 12;
    } else if (month + months < 1) {
      year--;
      month = 12 + month + months;
    } else {
      month = month + months;
    }
  }
  month = month < 10 ? "0" + month : month;
  var date = d.getDate();
  var firstday = year + "-" + month + "-" + "01";
  var lastday = "";
  if (
    month == "01" ||
    month == "03" ||
    month == "05" ||
    month == "07" ||
    month == "08" ||
    month == "10" ||
    month == "12"
  ) {
    lastday = year + "-" + month + "-" + 31;
  } else if (month == "02") {
    if (
      (year % 4 == 0 && year % 100 != 0) ||
      (year % 100 == 0 && year % 400 == 0)
    ) {
      lastday = year + "-" + month + "-" + 29;
    } else {
      lastday = year + "-" + month + "-" + 28;
    }
  } else {
    lastday = year + "-" + month + "-" + 30;
  }
  var day = "";
  if (type == "s") {
    day = firstday;
  } else {
    day = lastday;
  }
  return day;
};
